module.exports = __webpack_public_path__ + "img/notice.51d90602.jpg";